import auth from '@/service/auth'
import store from '@/store';

export const home = async (to, from, next) => {

  if (!auth.auth.isUserSignedIn()) {
    return next({path: '/auth/login'})
  }


  next({path: '/portal/inicio'})

}
export const is_auth = (to, from, next) => {


  if (!auth.auth.isUserSignedIn()) {
    store.commit('setLoggedIn', false);

    return next({path: '/login', query: {redirect: to.fullPath}});
  }

  store.dispatch('getUserInfo');

  next();
}


export const login = (to, from, next) => {

  auth.auth.getSession()
  next()
}

export const logout = (to, from, next) => {

  auth.logout();
  next();
}

export const oauth2 = (to, from, next) => {

  var currUrl = window.location.href

  auth.auth.parseCognitoWebResponse(currUrl)
  next()

}


export const logoutClaveUnica = (to, from, next) => {

  auth.logoutClaveUnica();
  next();
}
